<template>
  <main :class="['v-view-primary',
    ($store.getters.getAcademyData.persona === undefined && $store.getters.getAcademyData.is_licencia_paga) ||
    ($store.getters.getAcademyDaysLeft !== null && !$store.getters.getAcademyData.is_licencia_paga)
      ? 'v-view-primary-upgrade' : '']">
    <OrganismFeedSectionInfo />
    <OrganismTheHeader :is-loading="showAddingState"/>
    <OrganismFeedSectionLoading
      v-if="showLoadingState"
      key="loadingState"
    />
    <OrganismFeedSectionEmpty
      v-else-if="total === 0"
      key="emptyState"
    />
    <OrganismFeedSectionContent
      v-else
      key="idealState"
      :elements="elements"
      :showAddingState="showAddingState"
    />
  </main>
</template>

<script>
export default {
  name: 'FeedSection',

  components: {
    OrganismFeedSectionInfo: () => import('@/components/organisms/OrganismFeedSectionInfo'),
    OrganismFeedSectionLoading: () => import('@/components/organisms/OrganismFeedSectionLoading'),
    OrganismFeedSectionEmpty: () => import('@/components/organisms/OrganismFeedSectionEmpty'),
    OrganismFeedSectionContent: () => import('@/components/organisms/OrganismFeedSectionContent')
  },

  data () {
    return {
      academiaId: '',
      actualPage: 1,
      bottomPage: false,
      elements: [],
      list: [],
      pages: 0,
      projectType: 0,
      showAddingState: false,
      showLoadingState: true,
      total: 0
    }
  },

  computed: {
    endpoint () {
      if (this.$route.name === 'projects') {
        return 'readProyectosByAcademia'
      } else {
        return 'readProductos'
      }
    },

    entity () {
      if (this.$route.name === 'projects') {
        return 'proyecto'
      } else {
        return 'producto'
      }
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    // bottomPage (bottomPage) {
    //   if (bottomPage && this.list.length > 0) {
    //     this.elements = this.elements.concat(this.list.splice(0, 10))
    //   } else if (bottomPage && this.list.length === 0 && this.actualPage < this.pages) {
    //     this.actualPage++
    //     this.readElements()
    //   }
    // },

    $route (to, from) {
      this.resetProyecto()
      this.resetData()
      this.readElements()
    },

    updatedData () {
      if (this.$modal.methodToRun === 'deleteElement') {
        if (this.$route.name === 'products') {
          this.resetData()
          this.readElements()
        } else {
          this.deleteElement()
        }
      } else if (this.$modal.methodToRun === 'updateElement' && this.$route.name === 'projects') {
        this.readElements()
      }
    }
  },

  created () {
    this.resetProyecto()
    this.academiaId = this.$store.getters.getAcademyData.id

    window.addEventListener('scroll', () => {
      this.bottomPage = this.$utils.bottomVisible()
    })

    this.readElements()
  },

  methods: {
    deleteElement () {
      this.elements.splice(this.elements.findIndex(element => element.id === this.$modal.element.id), 1)
      this.$modal.closeModal()
    },

    readElements () {
      this.showAddingState = true
      // this.projectType = this.$route.name === 'assets' ? 0 : 1

      // let filter = this.entity === 'proyecto'
      //   ? { 'tipo': this.projectType }
      //   : {}
      let filter = {}

      this.$services.read(this.entity, this.endpoint, {}, [this.academiaId], filter)
        .then(response => {
          if (response.data.total > 0) {
            this.total = response.data.total
            this.list = this.entity === 'proyecto' ? response.data.proyectos : response.data.productos
            this.pages = this.entity === 'proyecto' ? response.data.paginas : response.data.pages
            if (this.entity === 'proyecto') {
              this.elements = this.actualPage === 1 ? this.list.splice(0, 10000) : this.elements.concat(this.list.splice(0, 10000))
            } else {
              this.elements = this.actualPage === 1 ? this.list.splice(0, 10000) : this.elements.concat(this.list.splice(0, 10000))
            }
          }
          this.showAddingState = false
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showAddingState = false
          this.showLoadingState = false
        })
    },

    resetData () {
      this.actualPage = 1
      this.bottomPage = false
      this.elements = []
      this.list = []
      this.pages = 0
      this.showAddingState = false
      this.showLoadingState = true
      this.total = 0
    },

    resetProyecto () {
      this.$store.commit('unsetAssetContents')
      this.$store.commit('unsetAssetNodes')
      this.$store.commit('unsetAssetSelectedDeliverable')
      this.$store.commit('unsetAssetSelectedNode')
      this.$store.commit('unsetAssetSelectedStudent')
    }
  }
}
</script>
